<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"  :query-api="checkQuery" :ignoreMaxTableItemLimit="true"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesStoolPoResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" :importEnabled="true" edit-disable="true" :ignoreMaxTableItemLimit="true"
                        ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"  :query-api="checkQuery"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template #left-header>
                  <b-button
                      :disabled="$store.state['sithMesStoolPo'].checkedItems.length < 1"
                      variant="outline-primary"
                      size="sm"
                      @click="showCheckersDialog()">指派检验员
                  </b-button>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <el-dialog title="请选择检验员" :visible.sync="dialogCheckerVisible">
      <el-form :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="请选择检验员" label-width="auto">
                <el-select v-model="checker" filterable multiple placeholder="请选择">
                    <el-option v-for="item in checkerOptions" :key="item.value" :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCheckerVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendToChecker()">确 定</el-button>
      </div>
    </el-dialog>
    /*
    <el-dialog title="数量" :visible.sync="sendListFlag">
      <el-form :model="form">
        <el-form-item label="请输入清单数量:" label-width="auto">
          <el-input-number v-model="listQuantity" :min="1" label="数量"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendListFlag = false">取 消</el-button>
        <el-button type="primary" @click="generateSendList()">确 定</el-button>
      </div>
    </el-dialog>
    */
  </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-07-06 09:52:28

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";

export default {
  name: "sithMesStoolPoListView",
  mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin, commonViewsUtil],
  data() {
    return {
      dialogCheckerVisible: false,
      checkerOptions:[],
      checker : [],
      checkQuery : 'findAllByCheckerFlag'
    }
  },
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return 'sithMesStoolPo';
    },
    entityBaseUrl() {
      return `${this.$_emApiMixin_entityBaseApi('sithMesStoolPo')}/`
    },
    headers() {
      let headers = {}
      let jwt = localStorage['em_sso_token']
      if (jwt != null) {
        headers['Authorization'] = jwt;
      }
      return headers;
    },
  },
  methods: {
    sendToChecker() {

        this.dialogCheckerVisible = false;

        const ids = this.$store.state[this.modelName]["checkedItems"].join(",");
        let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/sendToChecker?ids=" +　ids;
        this.$_emApiMixin_post(url, this.checker)
            .then(response => {
                commonViewsUtil.showSuccess(this, "通知完成！");
                this.$refs["emListFilter"].doQuery();
            })

    },
    showCheckersDialog() {
        this.dialogCheckerVisible = true;
        this.checkerOptions = [];
        var url = this.$store.state.emAclUser.baseModuleUrl + "/emAclUser";
        this.$store.dispatch("api/get", { url })
        .then(data => {
            data.forEach((item) => {
                this.checkerOptions.push({value:item['loginName'],label:item['name'] + '-'+item['loginName']});
            });
        });
    },
  },
  mounted() {
      this.$refs["emListFilter"].doQuery();
  }

};
</script>